import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { emptyArr, emptyObj } from '@beef/utils';
import { createMergedBlockSelector } from "../../selectors";
import { getBannerBlock, getHomeTariffBannerBlock } from "../selectors";
var getBannerData = createMergedBlockSelector(getBannerBlock);
var getHomeTariffBannerData = createMergedBlockSelector(getHomeTariffBannerBlock);
export var getBannerContentData = function getBannerContentData(state) {
  return getBannerData(state).banners || emptyArr;
};
export var getBannerSettings = function getBannerSettings(state) {
  return getBannerData(state).settings || emptyObj;
};
export var getHomeTariffBannerContentData = function getHomeTariffBannerContentData(state) {
  return getHomeTariffBannerData(state).banner || emptyObj;
};
export var getBannerTitleAtAnalytics = function getBannerTitleAtAnalytics(state) {
  var _getBannerContentData = getBannerContentData(state),
    _getBannerContentData2 = _slicedToArray(_getBannerContentData, 1),
    firstItem = _getBannerContentData2[0];
  return firstItem === null || firstItem === void 0 ? void 0 : firstItem.title;
};